'use strict';

import { mapGetters } from 'vuex';

export default {
  name: 'TimeFormatMixin',

  computed: {
    ...mapGetters('preferences', ['getUserTimeFormat', 'getUserTimeZone'])
  },

  methods: {
    getMessageTimeFormatted(messageTime) {
      let messageTimeFormatted = '';
      if (messageTime) {
        const lastMessageDateTime = this.$moment(messageTime);

        if (this.$moment().diff(lastMessageDateTime, 'hours') < 24) {
          messageTimeFormatted = this.applyTimeFormat(lastMessageDateTime, true);
        } else if (this.$moment().diff(lastMessageDateTime, 'days') < 365) {
          messageTimeFormatted = lastMessageDateTime.format('M/D');
        } else {
          messageTimeFormatted = lastMessageDateTime.format('M/D/YYYY');
        }
      }
      return messageTimeFormatted;
    },

    applyTimeFormat(value, applyUserTimeZone) {
      let formattedValue = '';

      if (value) {
        if (applyUserTimeZone) {
          formattedValue = this.$moment(value)
            .tz(this.getUserTimeZone)
            .format(this.getUserTimeFormat);
        } else {
          formattedValue = this.$moment(value).format(this.getUserTimeFormat);
        }
        if (formattedValue === 'Invalid date') {
          formattedValue = this.$moment(value, this.getUserTimeFormat).format(this.getUserTimeFormat);
        }
      }

      return formattedValue;
    }
  }
};
